import '../../css/nav.css';
import React, { useState, useEffect } from "react";
import { useNavigate, useLocation, Link } from 'react-router-dom';
import { Gauge } from "lucide-react";
import { useAuth } from '../../context/AuthContext';

const Nav = ({ isVisible, isCollapsed, closeNav }) => {
    const [manualNavIndex, setManualNavIndex] = useState(null);

    const currentYear = new Date().getFullYear();

    const navigate = useNavigate();

    const location = useLocation();

    const { role } = useAuth(); // "freelancer" or "business"

    const homePath = '/';

    // Build menu items based on role
    const menuItems = [
        {
            id: 1,
            label: "Home",
            path: homePath, // could be same Home component for all
            icon: "fas fa-home",
        },


        // Provider Directories
        ...(role !== "freelancer" && role !== "business"
            ? [
                {
                    id: 2,
                    label: "Freelancers",
                    path: "/freelancers",
                    icon: "fas fa-user",
                },
                {
                    id: 3,
                    label: "Businesses",
                    path: "/businesses",
                    icon: "fas fa-store",
                },
            ]
            : []
        ),

        {
            id: 4,
            label: "Service Requests",
            path: "/service-requests",
            icon: "fas fa-wrench",
        },

        // My Requests (ONLY freelancer & business)
        ...(role === "user"
            ? [
                {
                    id: 5,
                    label: "My Requests",
                    path: "/home/my-requests",
                    icon: "fas fa-wrench",
                }
            ]
            : []
        ),



        // Dashboard / Leads / Services (role-based)
        ...(role === "freelancer" || role === "business"
            ? [
                {
                    id: 6,
                    label: "My Leads",
                    path: role === "freelancer" ? "/home/freelancer-dashboard" : "/home/business-dashboard",
                    icon: "fas fa-hand-holding-dollar",
                }
            ]
            : []
        ),
    ];

    // Determine active menu index based on current path
    useEffect(() => {
        const currentPath = location.pathname;

        let foundIndex = menuItems.findIndex(item => {
            // Home special case: match all home variants
            if (item.path === homePath) {
                return (
                    currentPath === homePath ||
                    currentPath === "/home" ||
                    currentPath === "/home/freelancer-home" ||
                    currentPath === "/home/business-home"
                );
            }
            return currentPath === item.path;
        });

        if (foundIndex === -1) {
            // Check prefix match for nested pages
            foundIndex = menuItems.findIndex(item =>
                item.path !== homePath && currentPath.startsWith(item.path + "/")
            );
        }

        if (foundIndex !== -1) setManualNavIndex(foundIndex);
    }, [location.pathname, menuItems]);

    const handleMenuItemClick = (path, index) => {
        setManualNavIndex(index);
        navigate(path);
        if (window.innerWidth <= 768 && closeNav) {
            closeNav();
        }

    };

    return (
        <div className={`sidebar ${isVisible ? 'visible' : 'hidden'} ${isCollapsed ? 'collapsed' : ''}`}>

            {/* Menu items */}
            <div className="sidebar-menu">
                {menuItems.map((item, index) => (
                    <a
                        key={item.id}
                        href={item.path}
                        className={manualNavIndex === index ? "active" : ""}
                        onClick={(e) => {
                            e.preventDefault();
                            handleMenuItemClick(item.path, index);
                        }}
                    >
                        <div className="icon-wrapper">
                            {typeof item.icon === "string" ? <i className={item.icon}></i> : item.icon}
                        </div>
                        {!isCollapsed && <span>{item.label}</span>}
                    </a>
                ))}
            </div>

            {/* Footer divider */}
            <hr className="sidebar-menu-separator" />

            {/* Sidebar footer */}
            <div className="sidebar-footer">
                {!isCollapsed && (
                    <>
                        <p className="sidebar-copyright">
                            © {currentYear} AI ServSpace
                        </p>

                        <Link to="/terms-and-conditions" className="sidebar-footer-link">
                            Terms & Conditions
                        </Link>

                        <Link to="/privacy-policy" className="sidebar-footer-link">
                            Privacy Policy
                        </Link>
                    </>
                )}
            </div>
        </div>
    );
};

export default Nav;
